import { environment } from '../../environments/environment';
import { Observable, throwError } from 'rxjs';
import {HttpClient, HttpEvent, HttpHeaders} from '@angular/common/http';
import {ApiException} from '../_model/ApiException';

export class BaseService {
  // options: RequestOptions; // Removed because RequestOptions is not defined
  protected _baseUrl: string = environment._baseUrl;
  // tslint:disable-next-line:variable-name
  private _http: HttpClient;
  constructor(http: HttpClient) {
    this._http = http;
  }

  private handleError(error: Response) {
    const apiError: ApiException = {
      statusCode: error.status,
      statusText: error.statusText,
      url: error.url
    };

    return throwError(() => apiError || 'Server Error');
  }

  /*private handleError(operation = 'operation', result?: T) {
    return (error: any): Observable => {
      console.error(error);
      this.log(`${operation} failed: ${error.message}`);

      return of(result as T);
    };
  }*/

  protected get<T>(endPoint: string): Observable<T> {
    const options = this.InitHeader();
    const url: string = this._baseUrl + endPoint;
    return this._http.get<T>(url, {headers: options});
  }
  protected delete<T>(endPoint: string): Observable<T> {
    const options = this.InitHeader();
    const url: string = this._baseUrl + endPoint;
    return this._http.delete<T>(url, {headers: options});
  }

  protected post<T>(endPoint: string, request: any): Observable<T> {
    const options = this.InitHeader();
    const url: string = this._baseUrl + endPoint;
    return this._http.post<T>(url, request, {headers: options});
  }

  protected upload<T>(endPoint: string, request: any): Observable<HttpEvent<T>> {
    const url: string = this._baseUrl + endPoint;

    return this._http.post<T>(url, request, {
      reportProgress: true,
      observe: 'events'
    });
  }

  protected put<T>(endPoint: string, request: any): Observable<T> {
    const options = this.InitHeader();
    const url: string = this._baseUrl + endPoint;
    return this._http.put<T>(url, request, {headers: options});
  }

  private InitHeader(contentType?: string): HttpHeaders {
    if (contentType === undefined) {
      contentType = 'application/json';
    }
    const headers = new HttpHeaders()
      .append('Content-Type', contentType)
      .append('Accept', '*/*')
      .append('Accept-Language', 'tr-TR,tr;q=0.9,en-US;q=0.8,en;q=0.7');

    return headers;
  }
}
